import styled from 'styled-components';

export const SearchContainer = styled.div`
    position: relative;
    width: 100%;
    max-width: 500px;
`;

export const SearchIcon = styled.span`
    position: absolute;
    left: 1.2rem;
    top: 50%;
    transform: translateY(-50%);
    color: rgba(255, 255, 255, 0.5);
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 1rem 1.2rem 1rem 3.5rem;
    background: rgba(255, 255, 255, 0.1);
    border: 2px solid rgba(255, 255, 255, 0.1);
    border-radius: 15px;
    color: white;
    font-size: 1rem;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-sizing: border-box;

    &::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }

    &:focus {
        outline: none;
        border-color: #6b5bff;
        background: rgba(255, 255, 255, 0.15);
        box-shadow: 0 0 30px rgba(107, 91, 255, 0.3);
    }

    &:hover {
        border-color: rgba(255, 255, 255, 0.3);
    }
`;
